import { render, staticRenderFns } from "./Doc.vue?vue&type=template&id=f61df174"
import script from "./Doc.vue?vue&type=script&lang=js"
export * from "./Doc.vue?vue&type=script&lang=js"
import style0 from "./Doc.vue?vue&type=style&index=0&id=f61df174&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports